<template>
  <v-dialog v-model="dialog" width="700" scrollable>
    <v-card flat>
      <v-card-title class="pa-0">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer />
          <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
      </v-card-title>
      <base-table-header @search="onSearch" @reload="onReload">
        <template v-slot:subtitle>
          <div class="subtitle-1 black--text"> {{ total }} {{ title.split(' ')[1] || '-' }} </div>
        </template>
        <template v-slot:toolbar>
          <div style="max-width: 200px">
            <v-row no-gutters>
              <v-col v-if="false" cols="12" class="py-2 pr-1">
                <v-select
                  v-model="kategori"
                  light
                  flat
                  dense
                  outlined
                  hide-details
                  :items="mKategori"
                  @change="onChangeKategori"
                ></v-select>
              </v-col>
              <v-col cols="12" class="py-2 pr-1">
                <v-select
                  v-model="jenjang"
                  light
                  flat
                  dense
                  outlined
                  hide-details
                  :items="mJenjang"
                  @change="onChangeJenjang"
                ></v-select>
              </v-col>
            </v-row>
          </div>
        </template>
      </base-table-header>
      <v-divider />
      <v-card-text class="pa-0">
        <v-container>
          <div>
            <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
              <template slot-scope="{ item }">
                <td>
                  <v-list-item dense class="px-0" :disabled="disabled.includes(+item.sekolah_id)">
                    <v-list-item-avatar color="secondary">
                      <v-icon dark>mdi-hospital-building</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="12" lg="7">
                          <div class="body-1 info--text">{{ item.nama }}</div>
                          <div class="body-2">
                            <div><span class="font-weight-medium">NPSN: </span>{{ item.npsn }}</div>
                            <div><span class="font-weight-medium">Alamat: </span>{{ item.alamat }}</div>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="5" v-if="false">
                          <div class="body-2 grey--text">Kategori</div>
                          <v-icon :color="kategoris[item.k_kp_kategori_psp]" class="mr-0" size="30">
                            mdi-numeric-{{ item.k_kp_kategori_psp }}-circle
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action-text>
                      <v-btn
                        icon
                        :color="selectedItem.includes(+item.sekolah_id) ? 'success' : 'grey'"
                        @click="onSelectItem(item)"
                      >
                        <v-icon>
                          {{
                            selectedItem.includes(+item.sekolah_id)
                              ? 'mdi-checkbox-marked'
                              : 'mdi-checkbox-blank-outline'
                          }}
                        </v-icon>
                      </v-btn>
                    </v-list-item-action-text>
                  </v-list-item>
                </td>
              </template>
            </base-list-table>
          </div>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-row>
          <v-col cols="12">
            <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage" />
          </v-col>
          <v-col cols="12" class="text-right pt-0">
            <div>
              <span class="blue--text body-1">{{ selected.length || 0 }}</span> Sekolah Terpilih
            </div>
            <v-btn color="success" depressed @click="onSelect">Pilih Sekolah</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
export default {
  mixins: [list],
  props: {
    api: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    disable: {
      type: String,
      default: null,
    },
    labelDisable: {
      type: String,
      default: null,
    },
    customParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      fields: [],
      selected: [],
      disabled: [],
      kategori: '',
      jenjang: '',
      kategoris: {
        1: 'indigo',
        2: 'blue',
        3: 'cyan',
      },
    };
  },

  computed: {
    selectedItem() {
      return this.selected.map((item) => item.sekolah_id);
    },

    mKategori() {
      return [
        { text: 'Semua Kategori', value: '' },
        { text: 'Kategori 1', value: 1 },
        { text: 'Kategori 2', value: 2 },
        { text: 'Kategori 3', value: 3 },
      ];
    },

    mJenjang() {
      return [
        { text: 'Semua Jenjang', value: '' },
        { text: 'PAUD', value: 1 },
        { text: 'SD', value: 2 },
        { text: 'SMP', value: 3 },
        { text: 'SMA', value: 4 },
        { text: 'SMK', value: 5 },
        { text: 'SLB', value: 6 },
      ];
    },
  },

  methods: {
    fetchData() {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {}, this.customParams);
      this.$store.dispatch(this.api, { params: params, id: this.id }).then(({ data, meta }) => {
        this.data = data || [];
        this.total = meta?.total || 0;
        this.pageTotal = meta?.last_page || 1;
        this.params.limit = meta?.per_page || this.params.limit;
      });
    },

    open(fields, disabled) {
      this.dialog = true;
      this.fields = fields || [];
      this.data = [];
      this.selected = [];
      this.disabled = disabled || [];
      this.params = { page: 1, limit: 10 };
      this.kategori = '';
      this.jenjang = '';
      this.fetchData();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSelect() {
      this.resolve(this.selected);
      this.dialog = false;
    },

    onSelectItem(item) {
      const findIndex = this.selected.findIndex((s) => s.sekolah_id === item.sekolah_id);
      if (findIndex > -1) {
        this.selected.splice(findIndex, 1);
      } else {
        this.selected.push(item);
      }
    },

    onChangeKategori() {
      this.params.k_kp_kategori_psp = this.kategori;
      this.fetchData();
    },

    onChangeJenjang() {
      this.params.k_jenjang = this.jenjang;
      this.fetchData();
    },
  },
};
</script>
<style scoped>
>>> .v-dialog {
  overflow-y: hidden;
}
</style>
